const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

const IsWeixin = isWeixin();

export default {
  version: 'v2.0.0.stable',
  platform: IsWeixin ? 'wechat' : 'webApp', // 平台
  MaxSize: 10, // 最大上传体积(兆)
  payPath: ['/pay'],
  sharePath: [
    '/card/detail',
    '/circle/match',
    '/article/detail',
    '/webPage/detail',
    '/activity/invite',
    '/marketing/detail',
    '/activity/invitation'
  ],
  registerGuidPath: [
    '/card/detail',
    '/article/detail',
    '/webPage/detail',
    '/marketing/detail'
  ]
}



// WEBPACK FOOTER //
// ./src/config/index.js